var map = {
	"./de.json": [
		81649,
		[
			81649
		]
	],
	"./en.json": [
		7077,
		[
			7077
		]
	],
	"./fr.json": [
		87814,
		[
			87814
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 38967;
module.exports = webpackAsyncContext;